<pbc-filter [config]="KundenArtsFilterConfig" [filter]="kundenArts.filter$ | async" (filterChange)="kundenArts.filter$.next($event)"></pbc-filter>
